import { THEORETICAL_PREFIX } from '../hooks/useTheoreticalPassages'

window.rtknDebug = {
  setRealtimeError: (value) => {
    console.log('Setting realtime error to ' + value)
    window.localStorage.setItem('realtimeError', value)
  },
  setTheoreticalError: (value) => {
    console.log('Setting theoretical error to ' + value)
    window.localStorage.setItem('theoreticalError', value)
  },
  clearTheoreticalData: () => {
    console.log('Clear theoretical data')
    Object.keys(window.localStorage)
      .filter((localStorageKey) =>
        localStorageKey.startsWith(THEORETICAL_PREFIX),
      )
      .forEach((localStorageKey) => localStorage.removeItem(localStorageKey))
  },
}

export function isRealtimeError() {
  return window.localStorage.getItem('realtimeError') === 'true'
}

export function isTheoreticalError() {
  return window.localStorage.getItem('theoreticalError') === 'true'
}
